// Money, in the units the Exchange uses. See Design > Exchange, "Money".
// Asks, bids and answer prices are US dollars per million answers. Charges,
// refunds and balances are US dollars. One dollar per million is a millionth
// of a dollar per answer, so $200/M costs $0.0002.

/** US dollars, keeping the small amounts that answers cost: "$0.0002", "$9.9562". */
export function usd(dollars: number | null | undefined): string {
  if (dollars === null || dollars === undefined || !Number.isFinite(dollars)) return "–";
  const sign = dollars < 0 ? "−" : "";
  const abs = Math.abs(dollars);
  let text = abs.toFixed(6).replace(/0+$/, "");
  const decimals = text.split(".")[1]?.length ?? 0;
  if (decimals < 2) text = abs.toFixed(2);
  return `${sign}$${text.replace(/\.$/, "")}`;
}

/** An ask, a bid or a price: "$1,000/M". */
export function perMillion(value: number): string {
  return `$${value.toLocaleString("en-US", { maximumFractionDigits: 6 })}/M`;
}

/** What one answer costs, in US dollars, at a price per million answers. */
export const dollarsPerAnswer = (pricePerMillion: number): number => pricePerMillion / 1_000_000;
